import React, { useState, useEffect } from "react";
import { IoClose, IoPlayOutline, IoStopOutline } from "react-icons/io5";
import { MdOutlineSettings, MdOutlineVoiceOverOff } from "react-icons/md";
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from "react-icons/fi";
import { useSpeechSynthesis } from "react-speech-kit";
import { useStores } from "../../store";
const ReportVoiceOver = ({ isOpen, onClose, questions }) => {
  // const [voiceSpeed, setVoiceSpeed] = useState(1);
  // const [voicePitch, setVoicePitch] = useState(1);
  const [showSettings, setShowSettings] = useState(false);
  // const [isPlayingInterviewer, setIsPlayingInterviewer] = useState(false);
  // const [isPlayingCandidate, setIsPlayingCandidate] = useState(false);
  // const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  // const [isSequentialPlayback, setIsSequentialPlayback] = useState(false);
  // const [isPlaying, setIsPlaying] = useState("answer");

  const { CommonStore } = useStores();

  const { speak, cancel, speaking } = useSpeechSynthesis({
    onEnd: () => {
      CommonStore.setIsPlayingInterviewer(false);
      // After question ends, wait 1 second and then start playing the answer
      if (CommonStore.isPlaying === "answer") {
        setTimeout(async () => {
          await playAnswer();
          CommonStore.setIsPlayingCandidate(false);
          // Add 1 second delay after answer completion before moving to next question
          setTimeout(() => {
            CommonStore.setCurrentQuestionIndex(
              CommonStore.currentQuestionIndex + 1
            );
          }, 1000);
        }, 1000);
      }
      if (CommonStore.isPlaying === "question") {
        setTimeout(() => {
          handlePlayInterviewer();
          CommonStore.setIsPlaying("answer");
          CommonStore.setIsPlayingInterviewer(false);
        }, 1000);
      }
    },
  });

  if (!isOpen) return null;
  const stopAllPlayback = () => {
    cancel();
    CommonStore.setIsPlayingInterviewer(false);
    CommonStore.setIsPlayingCandidate(false);
    CommonStore.setIsSequentialPlayback(false);
  };

  const playAnswer = async () => {
    const answerText =
      questions[CommonStore.currentQuestionIndex]?.answer || "";
    if (answerText) {
      CommonStore.setIsPlayingCandidate(true);
      await speak({
        text: answerText,
        rate: Number(CommonStore.voiceSpeed),
        pitch: Number(CommonStore.voicePitch),
      });
      CommonStore.setIsPlaying("question");
    }
  };

  const handlePlayInterviewer = () => {
    // If anything is playing, stop it
    if (CommonStore.isPlayingInterviewer || CommonStore.isPlayingCandidate) {
      stopAllPlayback();
      return;
    }

    // Start playing the question
    const questionText =
      questions[CommonStore.currentQuestionIndex]?.question || "";
    if (questionText) {
      CommonStore.setIsPlayingInterviewer(true);
      CommonStore.setIsSequentialPlayback(true);
      speak({
        text: questionText,
        rate: Number(CommonStore.voiceSpeed),
        pitch: Number(CommonStore.voicePitch),
      });
    }
    CommonStore.setIsPlaying("answer");
  };

  const handlePlayCandidate = () => {
    // If anything is playing, stop it
    if (CommonStore.isPlayingInterviewer || CommonStore.isPlayingCandidate) {
      stopAllPlayback();
      return;
    }

    playAnswer();
  };

  const handleQuestionChange = (index) => {
    stopAllPlayback();
    CommonStore.setCurrentQuestionIndex(index);
  };

  const handlePreviousFive = () => {
    if (CommonStore.currentQuestionIndex >= 5) {
      handleQuestionChange(CommonStore.currentQuestionIndex - 5);
    } else {
      handleQuestionChange(0);
    }
  };

  const handleNextFive = () => {
    if (CommonStore.currentQuestionIndex < questions?.length - 5) {
      handleQuestionChange(CommonStore.currentQuestionIndex + 5);
    } else {
      handleQuestionChange(questions.length - 1);
    }
  };

  const handlePreviousQuestion = () => {
    if (CommonStore.currentQuestionIndex > 0) {
      handleQuestionChange(CommonStore.currentQuestionIndex - 1);
    }
  };

  const handleNextQuestion = () => {
    if (CommonStore.currentQuestionIndex < questions?.length - 1) {
      handleQuestionChange(CommonStore.currentQuestionIndex + 1);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-6xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-800">
            Voice Over Settings
          </h2>

          <div className="flex items-center justify-center gap-2">
            <button
              onClick={() => {
                CommonStore.setIsPlaying("question");
                handlePlayInterviewer();
              }}
              className="text-gray-500 hover:text-gray-700"
            >
              {CommonStore.isPlayingInterviewer ||
              CommonStore.isPlayingCandidate ? (
                <IoStopOutline size={24} />
              ) : (
                <IoPlayOutline size={24} />
              )}
            </button>

            <button
              onClick={() => setShowSettings(!showSettings)}
              className="text-gray-500 hover:text-gray-700"
            >
              <MdOutlineSettings size={24} />
            </button>
            <button
              onClick={() => {
                onClose();
                stopAllPlayback();
              }}
              className="text-gray-500 hover:text-gray-700"
            >
              <IoClose size={24} />
            </button>
          </div>
        </div>

        {/* Interviewer Section */}
        <div className="flex justify-between w-full mb-4">
          <p className="text-base font-medium">
            {(() => {
              const text =
                questions[CommonStore.currentQuestionIndex]?.question;
              if (typeof text !== "string") {
                return "Invalid question data";
              }
              return text;
            })()}
          </p>
          {/* <div>
            <button
              onClick={handlePlayInterviewer}
              className="text-gray-500 hover:text-gray-700"
            >
              {isPlayingInterviewer || isPlayingCandidate ? (
                <IoStopOutline size={24} />
              ) : (
                <IoPlayOutline size={24} />
              )}
            </button>
          </div> */}
        </div>

        {/* Candidate Section */}
        <div className="flex justify-between w-full mb-6">
          <p className="text-base font-medium overflow-y-auto h-[200px] no-scrollbar">
            {questions[CommonStore.currentQuestionIndex]?.answer ||
              "No answer available"}
          </p>
          {/* <div>
            <button
              onClick={handlePlayCandidate}
              className="text-gray-500 hover:text-gray-700"
            >
              {isPlayingCandidate ? (
                <IoStopOutline size={24} />
              ) : (
                <IoPlayOutline size={24} />
              )}
            </button>
          </div> */}
        </div>

        {showSettings && (
          <div className="space-y-4 mb-4">
            <div className="w-full gap-4 flex justify-between">
              <div className="w-[50%]">
                <label className="block text-xs font-normal text-gray-700 mb-1">
                  Voice Speed
                </label>
                <input
                  type="range"
                  min="0.5"
                  max="2"
                  step="0.1"
                  value={CommonStore.voiceSpeed}
                  onChange={(e) => CommonStore.setVoiceSpeed(e.target.value)}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>Slow</span>
                  <span>Fast</span>
                </div>
              </div>

              <div className="w-[50%]">
                <label className="block text-xs font-normal text-gray-700 mb-1">
                  Voice Pitch
                </label>
                <input
                  type="range"
                  min="0.5"
                  max="2"
                  step="0.1"
                  value={CommonStore.voicePitch}
                  onChange={(e) => CommonStore.setVoicePitch(e.target.value)}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>Low</span>
                  <span>High</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Question Numbers Navigation */}
        <div className="flex justify-center items-center gap-2 mt-4 border-t pt-4">
          <button
            onClick={handlePreviousFive}
            className={`p-1 rounded hover:bg-gray-100 transition-colors ${
              CommonStore.currentQuestionIndex === 0
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-600"
            }`}
            disabled={CommonStore.currentQuestionIndex === 0}
          >
            <FiChevronsLeft size={24} />
          </button>
          <button
            onClick={handlePreviousQuestion}
            className={`p-1 rounded hover:bg-gray-100 transition-colors ${
              CommonStore.currentQuestionIndex === 0
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-600"
            }`}
            disabled={CommonStore.currentQuestionIndex === 0}
          >
            <FiChevronLeft size={24} />
          </button>
          {questions?.length > 0 &&
            (() => {
              const totalPages = questions.length;
              let startPage = Math.max(
                0,
                Math.min(CommonStore.currentQuestionIndex - 2, totalPages - 5)
              );
              let endPage = Math.min(startPage + 5, totalPages);

              if (endPage - startPage < 5 && startPage > 0) {
                startPage = Math.max(0, endPage - 5);
              }

              return Array.from({ length: endPage - startPage }, (_, i) => {
                const pageNum = startPage + i;
                return (
                  <button
                    key={pageNum}
                    onClick={() => handleQuestionChange(pageNum)}
                    className={`w-8 h-8 rounded-full ${
                      CommonStore.currentQuestionIndex === pageNum
                        ? "bg-primary text-white"
                        : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                  >
                    {pageNum + 1}
                  </button>
                );
              });
            })()}
          <button
            onClick={handleNextQuestion}
            className={`p-1 rounded hover:bg-gray-100 transition-colors ${
              CommonStore.currentQuestionIndex >= questions?.length - 1
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-600"
            }`}
            disabled={CommonStore.currentQuestionIndex >= questions?.length - 1}
          >
            <FiChevronRight size={24} />
          </button>
          <button
            onClick={handleNextFive}
            className={`p-1 rounded hover:bg-gray-100 transition-colors ${
              CommonStore.currentQuestionIndex >= questions?.length - 5
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-600"
            }`}
            disabled={CommonStore.currentQuestionIndex >= questions?.length - 5}
          >
            <FiChevronsRight size={24} />
          </button>
        </div>

        <div className="flex justify-end space-x-4 mt-6">
          <button
            onClick={() => {
              onClose();
              stopAllPlayback();
            }}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
          >
            Cancel
          </button>
          {/* <button
            onClick={() => {
              onClose();
              stopAllPlayback();
            }}
            className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-primary-dark"
          >
            Apply
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default ReportVoiceOver;
